module.exports = __webpack_public_path__ + "static/hero-0303c3762ab401c917ce3cb0140e656c.png";